// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__25nSp","content":"styles_content__2HHfy","selectAll":"styles_selectAll__35PH2"};